const l = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle stroke="#DDD" stroke-width=".8" cx="16" cy="16" r="15.6" />
        <g fill="#2296F3" fill-rule="nonzero">
            <path
                d="M17.737 14.395a3.323 3.323 0 00-.34-.294.674.674 0 00-.984.919.677.677 0 00.166.143c.064.053.126.104.185.163l.055.055c.7.698.49 1.901-.208 2.6l-2.983 2.982a1.795 1.795 0 01-2.534 0l-.056-.056a1.792 1.792 0 010-2.534l1.318-1.317a.73.73 0 00-.455-1.306.729.729 0 00-.412.127l-.001-.003-.014.013a.737.737 0 00-.14.13L9.966 17.3a3.32 3.32 0 000 4.68l.056.056a3.32 3.32 0 004.68 0l2.982-2.982c1.285-1.287 1.394-3.318.109-4.604l-.055-.054z" />
            <path
                d="M22.035 10.02l-.056-.055a3.319 3.319 0 00-4.68 0l-2.981 2.983c-1.288 1.287-1.359 3.146-.071 4.434l.054.053c.059.059.12.114.181.167a.64.64 0 00.156.127h.002a.637.637 0 00.89-.829c-.084-.188-.242-.303-.35-.412l-.055-.054c-.7-.7-.434-1.715.265-2.414l2.984-2.981a1.792 1.792 0 012.532 0l.056.055a1.794 1.794 0 010 2.534l-1.313 1.314a.725.725 0 00.813 1.203l.002.004.02-.018a.73.73 0 00.166-.153l1.384-1.277a3.318 3.318 0 000-4.68z" />
        </g>
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=link-color.es.oFt13yko.js.map
